import PropTypes from 'prop-types';
import React, { useState, useEffect, useMemo, forwardRef } from 'react';
import _debounce from 'lodash/debounce';
import Input from '../Input/index.js';
const DebouncedInput = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    onChange = () => {},
    onChangeDuration = 250,
    value = '',
    disabled = false,
    onImmediateInputChange,
    ...rest
  } = _ref;
  const [inputValue, setInputValue] = useState(value);
  useEffect(() => {
    setInputValue(value);
  }, [value]);
  const debouncedOnChange = useMemo(() => _debounce(onChange, onChangeDuration), [onChange, onChangeDuration]);
  const handleChange = event => {
    event.persist();
    if (typeof onImmediateInputChange === 'function') {
      onImmediateInputChange(event);
    }
    setInputValue(event.target.value);
    debouncedOnChange(event);
  };
  return /*#__PURE__*/React.createElement(Input, Object.assign({
    "data-cmp": "debouncedInput"
  }, rest, {
    ref: ref,
    onChange: handleChange,
    value: inputValue,
    disabled: disabled
  }));
});
export default DebouncedInput;